export const RESULT = 1;
export const DOUBLE = 2;
export const HANDICAP = 3;
export const TOTAL = 4;




// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/constants/HeaderType.js